import { FolderKanban, SquareCheckBig } from 'lucide-react';
import { textoLivre } from '../../nucleo/formato';
import { caminhoDaAba, type FonteBuscaGlobal } from '../../nucleo/modulos-web';
import { i18n } from './i18n';

/**
 * Lista de 30/10 (item 10): tarefas (cards, pelo título) e projetos na busca da barra superior. A tarefa abre o drawer na
 * Lista (`?card=`); o projeto, na página Projetos (`?projeto=`), que também lê `?busca=` ("Ver todos").
 */
interface CardBusca {
  id: string;
  numero: number;
  titulo: string;
  quadro_nome: string;
  quadro_codigo: string | null;
  coluna_nome: string;
}
interface ProjetoBusca {
  id: string;
  nome: string;
  tarefas_abertas: number;
}

/** O nome do quadro de fábrica no idioma da tela (o de `useRotuloQuadro`, sem o hook). */
const nomeDoQuadro = (c: CardBusca, t: (k: string) => string) => {
  const fabrica = c.quadro_codigo ? (i18n.pt.quadrosPadrao as Record<string, string>)[c.quadro_codigo] : undefined;
  return fabrica && fabrica === c.quadro_nome ? t(`quadrosPadrao.${c.quadro_codigo}`) : textoLivre(c.quadro_nome);
};

export const buscaTarefas: FonteBuscaGlobal[] = [
  {
    chave: 'cards',
    permissao: 'tarefas.ver',
    pagina: 'tarefas.lista',
    grupo: 'buscaGlobal.cards',
    posicao: 40,
    icone: SquareCheckBig,
    item: (c: CardBusca, t) => ({ id: c.id, rotulo: textoLivre(c.titulo), detalhe: `#${c.numero} · ${nomeDoQuadro(c, t)}`, link: `${caminhoDaAba('tarefas', 'lista')}?card=${c.id}` }),
  },
  {
    chave: 'projetos',
    permissao: 'tarefas.ver',
    pagina: 'tarefas.projetos',
    grupo: 'buscaGlobal.projetos',
    posicao: 45,
    icone: FolderKanban,
    item: (p: ProjetoBusca) => ({ id: p.id, rotulo: textoLivre(p.nome), link: `${caminhoDaAba('tarefas', 'projetos')}?projeto=${p.id}` }),
    verTodos: (termo) => `${caminhoDaAba('tarefas', 'projetos')}?busca=${encodeURIComponent(termo)}`,
  },
];
